import Vue from 'vue'
import initialState from './defaultState'

export default {
    resetStateMutation(state) {
        const defaultState = initialState();

        Object.keys(state).forEach(item => {
            Vue.set(state, item, defaultState[item]);
        })
    },

    showAppointments(state) {
        state.appointmentsIsShow = true;
        state.attendanceIsShow = false;
        state.appointmentObject = undefined
    },

    showAttendanceTable(state, data) {
        state.appointmentsIsShow = false;
        state.attendanceIsShow = true;
        state.appointmentObject = data
    },
}
